/** @format */

import {Box, styled} from '@mui/material';

const LoaderContainer = styled(Box)(() => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  height: '100%',
  backgroundColor: '#2d2d2d',
}));

const SlashLine = styled(Box)(({theme}) => ({
  width: '1px',
  height: theme.spacing(6),
  backgroundColor: theme.palette.figma_gray_middle_dark?.main,
  margin: theme.spacing(1),
  transform: 'rotate(20deg)',
}));

interface SlashLoaderProps {
  fullScreen?: boolean;
}

const SlashLoader = ({fullScreen = true}: SlashLoaderProps) => {
  const Container = fullScreen ? LoaderContainer : Box;

  return (
    <Container
      sx={
        !fullScreen
          ? {
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              p: 4,
            }
          : undefined
      }
    >
      <Box display='flex' alignItems='center'>
        <SlashLine />
        <SlashLine />
        <SlashLine />
      </Box>
    </Container>
  );
};

export default SlashLoader;
